import { Box, styled } from "@mui/material";

export const RideNotAvailableText = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh"
});

export const RideMapContainer = styled(Box)({
  height: "100vh",
  width: "100%",

  ".gm-style-iw.gm-style-iw-c": {
    background: "none",
    boxShadow: "none"
  },
  "button.gm-ui-hover-effect": {
    top: "6px !important",
    "& span": {
      backgroundColor: "#ffffff !important"
    }
  },
  ".gm-style-iw-d": {
    overflow: "hidden !important"
  },
  ".gm-style .gm-style-iw-tc::after": {
    background: "#192026E0"
  },
  ".gmnoprint .gm-style-mtc": {
    display: "none"
  },
  "button.gm-control-active.gm-fullscreen-control": {
    display: "none"
  },
  ".gm-style-iw-c:has([data-testid='mixed-ride-segment-popup'])": {
    background: "#ffffff !important",
    padding: "0 !important",
    borderRadius: "12px !important",
    boxShadow: "0 8px 28px rgba(29, 31, 43, 0.16) !important",
    overflow: "hidden !important",
    maxWidth: "none !important"
  },
  ".gm-style-iw-d:has([data-testid='mixed-ride-segment-popup'])": {
    overflow: "hidden !important",
    background: "#ffffff !important"
  },
  ".gm-style-iw-t:has([data-testid='mixed-ride-segment-popup']) .gm-style-iw-tc":
    {
      display: "none !important"
    },
  ".gm-style-iw-t:has([data-testid='mixed-ride-segment-popup']) .gm-style-iw-ch":
    {
      display: "none !important",
      height: "0 !important"
    },
  ".gm-style-iw-t:has([data-testid='mixed-ride-segment-popup']) button.gm-ui-hover-effect":
    {
      display: "none !important"
    }
});
